// A bulk toast's description: on a partial success, deal rows' own messages when there are any,
// else the generic partial-success text; on a full failure, the row messages if any.
// Joined: antd runs an array of strings together with no separator.
const getRowErrorsDescription = (
  errors: string[] | undefined,
  isDeal: boolean,
  isPartialSuccess: boolean,
  partialSuccessText: string
): string | undefined => {
  if (isPartialSuccess) {
    return isDeal && errors?.length ? errors.join("; ") : partialSuccessText;
  }
  return errors?.length ? errors.join("; ") : undefined;
};

export default getRowErrorsDescription;
